interface PontuacaoBarProps {
  chefe: number;
  cca: number;
}

function Bar({ value, color, label }: { value: number; color: string; label: string }) {
  const pct = Math.min((value / 5) * 100, 100);
  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-slate-400 w-8 flex-shrink-0">{label}</span>
      <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-500 ${color}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="text-xs font-semibold text-slate-700 w-8 text-right flex-shrink-0">
        {value.toFixed(1)}
      </span>
    </div>
  );
}

export default function PontuacaoBar({ chefe, cca }: PontuacaoBarProps) {
  const diff = (cca - chefe).toFixed(1);
  const diffNum = parseFloat(diff);
  return (
    <div className="space-y-1.5 min-w-[160px]">
      <Bar value={chefe} color="bg-slate-400" label="Chefe" />
      <Bar value={cca} color="bg-emerald-500" label="CCA" />
      {diffNum !== 0 && (
        <p className={`text-xs ${diffNum > 0 ? 'text-emerald-600' : 'text-rose-500'} text-right`}>
          {diffNum > 0 ? '+' : ''}{diff} CCA
        </p>
      )}
    </div>
  );
}
